// Presentation only — which step is current/completed/clickable is decided
// by the caller (AddContent.js), which is the one place that knows about
// Formik validity. A step is clickable only up to the furthest step the
// admin has already reached, so jumping ahead by clicking still requires
// going through Next's validation gate at least once.
export default function WizardStepper({ steps, currentStep, maxStepReached, onStepClick }) {
    return (
        <div className="wizard-stepper">
            {steps.map((step, index) => {
                const isCompleted = index < currentStep;
                const isCurrent = index === currentStep;
                const isClickable = index <= maxStepReached && index !== currentStep;

                return (
                    <div className="wizard-step-item" key={step.key}>
                        <div className="wizard-step-marker-col">
                            <button
                                type="button"
                                className={`wizard-step-circle${isCurrent ? " current" : ""}${isCompleted ? " completed" : ""}`}
                                onClick={() => isClickable && onStepClick(index)}
                                disabled={!isClickable}
                                aria-current={isCurrent ? "step" : undefined}
                            >
                                {isCompleted ? "✓" : index + 1}
                            </button>
                            <div className={`wizard-step-label${isCurrent ? " current" : ""}`}>{step.label}</div>
                        </div>
                        {index < steps.length - 1 && (
                            <div className={`wizard-step-line${isCompleted ? " completed" : ""}`} />
                        )}
                    </div>
                );
            })}
        </div>
    );
}
